import styled from 'styled-components';

const AssignDateModalInner = styled.div`
  padding: 20px 0;
  width: 320px;
  height: 200px;
  background-color: white;
  border-radius: 4px;
  margin: auto;
  display: flex;
  justify-content: center;
  & div[class*='ButtonWrapper'] {
    border-radius: 4px;
  }
`;

export default AssignDateModalInner;


// WEBPACK FOOTER //
// ./components/footer/assign-button/assign-date-modal/styled.js